import {ValueOf} from "./types";

export type I18nNamespace = ValueOf<typeof I18nNamespace>;
export const I18nNamespace = {
  MAIN: "website",
  DB: "website-db",
  WEB_SCHEDULING: "web-scheduling",
} as const;
